var styles = {"Dialog":"ooby-e095NI-","Panel":"eF83HUv91mg-","enterFrom":"qHDJ5Y4MRfw-","leaveTo":"wImnBWuOaeA-","small":"vCfdVw1V6Dk-","base":"_0XmKOJ5hDlk-","large":"suJn68jKIwk-","pinToTop":"wNe0eFdKs5E-","Overlay":"iCg-JmudeLo-","TitleBar":"wvkeil-1qyM-","TitleBarDivider":"-v31HUSIWD4-","Content":"ow2iCordrK8-","inset":"EFHYLg-HiXI-","closeButton":"_4gw63G7IYG0-"};

export { styles as default };
//# sourceMappingURL=Modal.module.css.js.map
